import type { Locale } from '$core/i18n/catalogs';
import type { Theme } from '$domain/types';
import {
  DEFAULT_SHORTCUTS,
  type ShortcutMap
} from '$features/session/keys';

export interface LastContext {
  nodeId: string | null;
  path: string[];
}

export type UiStyle = 'minimal' | 'retro';

export interface UserPreferences {
  blindMode: boolean;
  locale: Locale;
  theme: Theme;
  style: UiStyle;
  shortcuts: ShortcutMap;
  lastContext: LastContext | null;
  leaderboardOptIn: boolean;
  leaderboardDisplayName: string | null;
  leaderboardCountry: string;
  pushEnabled: boolean;
  pushReminderHour: number;
  showFrustration: boolean;
  showEnergy: boolean;
  showReadingTime: boolean;
  showDistractions: boolean;
  showSessionContextBar: boolean;
  hideCompleted: boolean;
  alarmEnabled: boolean;
  keepScreenAwake: boolean;
  problemTimerMode: 'timer' | 'countdown';
  countdownDurationMs: number;
}

export const DEFAULT_PREFERENCES: UserPreferences = {
  blindMode: false,
  locale: 'en',
  theme: 'wine',
  style: 'minimal',
  shortcuts: { ...DEFAULT_SHORTCUTS },
  lastContext: null,
  // Leaderboard ON por defecto (opción D): el usuario aparece en el ranking
  // solo cuando elige un nombre público (se le pide al entrar a Leaderboard).
  // Puede desactivarlo desde Preferences.
  leaderboardOptIn: true,
  leaderboardDisplayName: null,
  leaderboardCountry: 'pirate',
  pushEnabled: false,
  pushReminderHour: 20,
  showFrustration: false,
  showEnergy: false,
  showReadingTime: false,
  showDistractions: false,
  showSessionContextBar: false,
  hideCompleted: false,
  alarmEnabled: true,
  keepScreenAwake: true,
  problemTimerMode: 'timer',
  countdownDurationMs: 3 * 60 * 1000
};